const getTrackingContext = () => {
  /* eslint-disable no-underscore-dangle */
  if (window._Cohesion) {
    return {
      tenantId: window._Cohesion.tenantId,
      webContext: window._Cohesion.webContext,
      writeKey: window._Cohesion.writeKey,
      formatType: 'spp-cta',
      /* eslint-enable no-underscore-dangle */
    };
  }
  return {};
};

export default getTrackingContext;
